import { createReducer } from '@reduxjs/toolkit';
import equipmentScheduleOrderPageActions from './equipmentScheduleOrderPageActions';

const initialState = {
  colorGroups: {}, // { [locationId]: ColorGroup[] }
  equipmentOrderInColorGroups: {}, // { [locationId]: EquipmentOrderInColorGroup[] }
  isLoading: false,
  isError: null,
};

const equipmentScheduleOrder = createReducer(initialState, {
  [equipmentScheduleOrderPageActions.getEquipmentScheduleOrdersData]: (state, { payload }) => {
    return {
      ...state,
      colorGroups: payload.colorGroups,
      equipmentOrderInColorGroups: payload.equipmentOrderInColorGroups,
    };
  },
  [equipmentScheduleOrderPageActions.equipmentScheduleOrdersError]: (state, { payload }) => {
    return {
      ...state,
      isError: payload,
    };
  },
  [equipmentScheduleOrderPageActions.updateEquipmentGroupsOrdersData]: (state, { payload }) => {
    return {
      ...state,
      colorGroups: payload.colorGroups,
    };
  },
  [equipmentScheduleOrderPageActions.updateEquipmentScheduleOrder]: (state, { payload }) => {
    return {
      ...state,
      colorGroups: payload.colorGroups,
      equipmentOrderInColorGroups: payload.equipmentOrderInColorGroups,
    };
  },
});

export default equipmentScheduleOrder;